export const API_URL =
  "localhost" === window.location.hostname
    ? "http://local.espace-client.api/api"
    : "https://api-client.eosia.fr/api";
